export default [
    
    /*{
    id: "72401",
    name: "Hospital Universitario Y Politécnico La Fe",
},*/

{
    id: "72402",
    name: "CHUS – H. Clinico U. de Santiago",
},{
    id: "72403",
    name: "Hospital Universitario de Bellvitge",
}, ];